<template>
  <div class="toolbar-menu">

    <a href="http://wpa.qq.com/msgrd?v=3&uin=2850559846&site=qq&menu=yes" target="_blank" class="btn btn-qq">
      <i class="fa fa-qq"></i>
      <br>在线客服</a>
    <router-link to="/helpList/在线反馈" class="btn btn-qq">
      <i class="fa fa-comments"></i>
      <br>在线反馈</router-link>  
    <div class="btn btn-phone">
      <i class="fa fa-phone"></i>
      <br>客服电话
      <div class="phone">
        0755-82405890</div>
    </div>
    <div class="btn btn-phone2">
      <i class="fa fa-mobile-phone"></i>
      <br>手机号码
      <div class="phone2">189-2386-5746(销售部)<br>
      189-2459-0809(采购部)</div>
    </div>
    <a href="mailto:atm8123@spr-atm.com" class="btn btn-phone3">
      <i class="fa fa-envelope-o"></i>
      <br>客服邮箱
      <div class="phone3">atm8123@spr-atm.com</div>
    </a>
    <router-link to="/help" class="btn btn-qq">
      <i class="fa fa-question-circle"></i>
      <br>帮助中心
    </router-link>
    <div :class="['btn', 'btn-top', visible ? '': 'hidden']" @click="scrollTop">
      <i class="fa fa-arrow-up"></i>
      <br>TOP</div>
  </div>
</template>

<script>
let timer
export default {
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    scrollTop() {
      if (timer) return
      timer = setInterval(() => {
        if (window.scrollY > 0) {
          window.scroll(0, window.scrollY - 30)
        } else {
          clearInterval(timer)
          timer = null
        }
      })
    },
  },
  mounted() {
    window.addEventListener('scroll', e => {
      if (window.scrollY > 200) {
        this.$set(this, 'visible', true)
      } else {
        this.$set(this, 'visible', false)
      }
    })
  },
}
</script>

<style lang="less" scoped>
.toolbar-menu {
  font-size: 12px;
  -webkit-font-smoothing: antialiased;
  & .btn {
    width: 72px;
    height: 72px;
    margin-bottom: 1px;
    cursor: pointer;
    position: relative;
    display: block;
    color: #333;
    background: #fff;
    text-align: center;
    border-radius: 3px;
    &:hover {
      background-color: #34a8ff;
      color: #fff;
      .phone, .phone2, .phone3 {
        display: block;
      }
    }
    i {
      font-size: 28px;
      padding: 12px 0 5px 0;
    }
  }
}

.btn-qq {
  text-decoration: none;
}

.btn-phone .phone, .btn-phone2 .phone2, .btn-phone3 .phone3{
  position: absolute;
  width: 160px;
  left: -157px;
  top: 0;
  line-height: 26px;
  padding: 10px 0 10px 0;
  color: #FFF;
  font-size: 14px;
  text-align: center;
  display: none;
  background-color: #34a8ff;
}

.phone{
  line-height: 52px !important;
}

.btn-phone2 .phone2, .btn-phone3 .phone3 {
  box-sizing: border-box;
  font-size: 12px;
  padding: 0;
  height: 72px;
  padding-top: 10px;
}
.btn-phone3 .phone3 {
  left: -207px;
  width: 210px;
  line-height: 52px !important;
}
.btn-top {
  height: 72px;
  transition: height 0.2s ease;
  overflow: hidden;
  &.hidden {
    height: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ToolBar.vue?2bf9ff33